/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Companion_TitleInputs */

const en_lg_companion_title = /** @type {(inputs: Lg_Companion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar companion setup`)
};

const id_lg_companion_title = /** @type {(inputs: Lg_Companion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan Calendar companion`)
};

/**
* | output |
* | --- |
* | "Calendar companion setup" |
*
* @param {Lg_Companion_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_companion_title = /** @type {((inputs?: Lg_Companion_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Companion_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_companion_title(inputs)
	return en_lg_companion_title(inputs)
});